module.exports = __webpack_public_path__ + "img/1280x720-Hohoho.46096dfa.jpg";